var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "main-lmd-logs" },
          [
            _c(
              "div",
              { staticClass: "filter-container" },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 3 } },
                      [
                        _c("el-date-picker", {
                          staticClass: "w-100",
                          attrs: {
                            type: "date",
                            clearable: false,
                            placeholder: _vm.$t("dateRange.date"),
                            "value-format": "yyyy-MM-dd",
                            "picker-options": { firstDayOfWeek: 7 },
                          },
                          model: {
                            value: _vm.code,
                            callback: function ($$v) {
                              _vm.code = $$v
                            },
                            expression: "code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticClass: "ml-2", attrs: { span: 3 } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              placeholder: _vm.$t(
                                "planning.columns.plateNumber"
                              ),
                            },
                            model: {
                              value: _vm.plateNumber,
                              callback: function ($$v) {
                                _vm.plateNumber = $$v
                              },
                              expression: "plateNumber",
                            },
                          },
                          _vm._l(_vm.truckData, function (tData) {
                            return _c("el-option", {
                              key: tData.plateNumber,
                              attrs: {
                                label: tData.plateNumber,
                                value: tData.plateNumber,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticClass: "ml-2", attrs: { span: 12 } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: !_vm.plateNumber,
                            },
                            on: { click: _vm.getLogsData },
                          },
                          [_vm._v(_vm._s(_vm.$t("general.search")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-table",
              { attrs: { data: _vm.data, height: 700 } },
              [
                _c("el-table-column", {
                  attrs: { type: "index", width: "50" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "code",
                    label: _vm.$t("planning.columns.planCode"),
                    width: "150",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(" " + _vm._s(scope.row.code) + " ")]
                        },
                      },
                    ],
                    null,
                    false,
                    3302545424
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "userEmail",
                    label: _vm.$t("planning.columns.userId"),
                    width: "200",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.userEmail) + " "),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2957335040
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "type",
                    label: _vm.$t("general.type"),
                    width: "250",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.data.type.toUpperCase()) +
                                " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    631224665
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "message",
                    label: _vm.$t("general.message"),
                    width: "250",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.message.toUpperCase()) +
                                " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    634759604
                  ),
                }),
                _c("el-table-column", {
                  attrs: { prop: "data", label: _vm.$t("general.details") },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("planning.columns.plateNumber")
                                  ) + ":"
                                ),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(scope.row.data.plateNumber || "") +
                                  " (" +
                                  _vm._s(scope.row.data.vehicleId || "") +
                                  ") (" +
                                  _vm._s(scope.row.data.routesLength || 0) +
                                  ")"
                              ),
                            ]),
                            _c("div", [
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.$t("planning.columns.planId")) +
                                    " (" +
                                    _vm._s(scope.row.data.planId.length) +
                                    "):"
                                ),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (scope.row.data.planId || []).join(", ")
                                  )
                              ),
                            ]),
                            _c("div", [
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.$t("planning.columns.orderId")) +
                                    " (" +
                                    _vm._s(scope.row.data.orderId.length) +
                                    "):"
                                ),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (scope.row.data.orderId || []).join(", ")
                                  )
                              ),
                            ]),
                            _c("div", [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("planning.columns.shipmentReference")
                                  ) +
                                    " (" +
                                    _vm._s(
                                      scope.row.data.shipmentReference.length
                                    ) +
                                    "):"
                                ),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (
                                      scope.row.data.shipmentReference || []
                                    ).join(", ")
                                  )
                              ),
                            ]),
                            scope.row.data.params && scope.row.data.params.data
                              ? _c("div", [
                                  _c("p", { staticClass: "p-0 m-0" }, [
                                    _vm._v(_vm._s(_vm.$t("general.info"))),
                                  ]),
                                  _c("p", { staticClass: "p-0 m-0" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("general.message")) +
                                        ": " +
                                        _vm._s(
                                          scope.row.data.params.data.orderstatus
                                            ? scope.row.data.params.data.orderstatus.toUpperCase()
                                            : ""
                                        )
                                    ),
                                  ]),
                                  Array.isArray(scope.row.data.params.data.data)
                                    ? _c("p", { staticClass: "p-0 m-0" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.columns.orderId")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.params.data.data
                                                .map(function (pData) {
                                                  return pData["orderid"] || ""
                                                })
                                                .join(", ")
                                            )
                                        ),
                                      ])
                                    : _c("p", { staticClass: "p-0 m-0" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.columns.orderId")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.params.data.data
                                                .orderid || ""
                                            ) +
                                            " - " +
                                            _vm._s(
                                              scope.row.data.params.data.data
                                                .line || ""
                                            )
                                        ),
                                      ]),
                                  scope.row.data.params.data.shipref
                                    ? _c("p", { staticClass: "p-0 m-0" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.shipmentReference"
                                            )
                                          ) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.params.data
                                                .shipref || ""
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3722761599
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createdAt",
                    label: _vm.$t("general.createdAt"),
                    width: "150",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("convertTimezone")(
                                    scope.row.createdAt,
                                    _vm.$timezone,
                                    "YY-MM-DD HH:mm"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2043255032
                  ),
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }